
import { i18nText } from '@/locales';
export const  notSelected = [{id:null, name:i18nText("Не указано")}]
